import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onBeforeMount } from 'vue'
import { useFetch } from '@vueuse/core'
import BaseTypeAhead from './BaseTypeAhead.vue'
import { useI18n } from 'vue-i18n'
import { useAuthenticateSAML } from '../store/useAuthenticateSAML'
import { Notify } from 'quasar'

//translations

export default /*#__PURE__*/_defineComponent({
  __name: 'TypeAheadUsers',
  props: {
    rules: { default: undefined },
    modelValue: {},
    label: {},
    username: { default: undefined },
    route: { default: '/api/users' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n({ useScope: 'global' })
const errorMessage = (key: string) => t(`form.messages.${key}`)

//component setup
const props = __props
const emit = __emit
const currentValue = ref()
onBeforeMount(() => {
  if (props.username) {
    currentValue.value = props.username
    emit('update:modelValue', currentValue.value)
  }
})

const update = (e: any) => {
  currentValue.value = e
  emit('update:modelValue', e)
}

const { data } = props.username
  ? { data: [] }
  : useFetch(props.route, {
      async beforeFetch({ options, cancel }) {
        const { getJWT } = useAuthenticateSAML()
        if (!getJWT || !getJWT.token) cancel() //TODO: notify

        options.headers = {
          ...options.headers,
          Authorization: `Bearer ${getJWT.token}`,
        }

        return {
          options,
        }
      },
      async onFetchError(ctx) {
        Notify.create({
          type: 'negative',
          timeout: 5000,
          position: 'bottom-left',
          message: 'An error ocurred grabbing users.',
        })
        return ctx
      },
    })
      .post({})
      .json()

const BaseTypeAheadRef = ref()
__expose({
  validate: () =>
    BaseTypeAheadRef.value ? BaseTypeAheadRef.value.validate() : console.log('no ref exists yet'),
})

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_unref(data))
    ? (_openBlock(), _createBlock(BaseTypeAhead, {
        key: 0,
        ref_key: "BaseTypeAheadRef",
        ref: BaseTypeAheadRef,
        label: _ctx.label,
        selected: currentValue.value,
        "onUpdate:selected": [
          _cache[0] || (_cache[0] = ($event: any) => ((currentValue).value = $event)),
          update
        ],
        "dropdown-options": _unref(data),
        "search-keys": ['username', 'first_name', 'last_name'],
        rules: _ctx.rules
      }, {
        "selected-item": _withCtx(({ opt }) => [
          _createTextVNode(_toDisplayString(`${opt.first_name} ${opt.last_name}`), 1)
        ]),
        option: _withCtx(({ opt }) => [
          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
            clickable: "",
            onClick: ($event: any) => (currentValue.value = opt)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`${opt.first_name} ${opt.last_name}`), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_item_label, { caption: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(opt.username), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_close_popup]
          ])
        ]),
        "no-option": _withCtx(() => [
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "text-grey" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(errorMessage('noResults')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label", "selected", "dropdown-options", "rules"]))
    : _createCommentVNode("", true)
}
}

})